import React, { useEffect, useState } from "react";
import { createCollege, getAllCity, getAllCollegePagination, getCalendars } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddCollege = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        name: "",
        title: "",
        description: "",
        city_id: "",
        id: "",
        establish_year: "",
        gender_preference: "",
        institutuion_type: "",
        campus_size: "",
        calendar_system_id: "",
        student_count: "",
        parent_id: "",
        percent_international_student: "",
        acceptance_ratio: "",
        avg_cost_living: "",
        college_rank: "",
        website_url: ""
    });
    const [loader, setLoader] = useState(false);
    const [city, setCity] = useState([]);
    const [college, setCollege] = useState([]);
    const [calendar, setCalendar] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCollege(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllCityCall = async () => {
        let { ok, data } = await getAllCity({});
        if (ok) {
            setCity(data?.records);
        }
    };

    const getAllCalendarCall = async () => {
        let { ok, data } = await getCalendars({});
        if (ok) {
            setCalendar(data?.records);
        }
    };

    const getAllCollegeCall = async () => {
        let { ok, data } = await getAllCollegePagination({});
        if (ok) {
            setCollege(data?.records);
        }
    };

    useEffect(() => {
        getAllCalendarCall();
        getAllCityCall();
        getAllCollegeCall();
        if (data?.data) {
            const { name, title, description, city_id, id, establish_year, gender_preference, institutuion_type, campus_size, calendar_system_id, student_count, parent_id, percent_international_student, acceptance_ratio, avg_cost_living, college_rank, website_url, tags } = data?.data;
            setReqData({ name, title, description, city_id, id, establish_year, gender_preference, institutuion_type, campus_size, calendar_system_id, student_count, parent_id, percent_international_student, acceptance_ratio, avg_cost_living, college_rank, website_url, tags })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add College" : "Edit College"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="column">
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Name"
                                                    required
                                                    value={reqData?.name}
                                                    onChange={(e) => handleChange("name", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Title</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Title"
                                                    required
                                                    value={reqData?.title}
                                                    onChange={(e) => handleChange("title", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Establish Year</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Establish Year"
                                                    required
                                                    value={reqData?.establish_year}
                                                    onChange={(e) => handleChange("establish_year", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Gender Preference</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Gender Preference"
                                                    required
                                                    value={reqData?.gender_preference}
                                                    onChange={(e) => handleChange("gender_preference", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Institution Type</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Institution Type"
                                                    required
                                                    value={reqData?.institutuion_type}
                                                    onChange={(e) => handleChange("institutuion_type", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Campus Size</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Campus Size"
                                                    required
                                                    value={reqData?.campus_size}
                                                    onChange={(e) => handleChange("campus_size", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Student Count</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Student Count"
                                                    required
                                                    value={reqData?.student_count}
                                                    onChange={(e) => handleChange("student_count", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>International Student (%)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="International Student (%)"
                                                    required
                                                    value={reqData?.percent_international_student}
                                                    onChange={(e) => handleChange("percent_international_student", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Acceptance Ratio</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Acceptance Ratio"
                                                    required
                                                    value={reqData?.acceptance_ratio}
                                                    onChange={(e) => handleChange("acceptance_ratio", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Cost Of Living</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Cost Of Living"
                                                    required
                                                    value={reqData?.avg_cost_living}
                                                    onChange={(e) => handleChange("avg_cost_living", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>College Rank</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="College Rank"
                                                    required
                                                    value={reqData?.college_rank}
                                                    onChange={(e) => handleChange("college_rank", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Website</label>
                                                <input
                                                    type="url"
                                                    className="form-control"
                                                    placeholder="Website"
                                                    value={reqData?.website_url}
                                                    onChange={(e) => handleChange("website_url", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>City</label>
                                                <select required value={reqData?.city_id} onChange={(e) => handleChange("city_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                    <option selected>Select City</option>
                                                    {city?.map(obj =>
                                                        <>
                                                            <option value={obj?.id}>{obj?.name}</option>
                                                        </>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Parent</label>
                                                <select required value={reqData?.parent_id} onChange={(e) => handleChange("parent_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                    <option selected>Select Parent</option>
                                                    {college?.map(obj =>
                                                        <>
                                                            <option value={obj?.id}>{obj?.name}</option>
                                                        </>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Calendar System</label>
                                                <select required value={reqData?.calendar_system_id} onChange={(e) => handleChange("calendar_system_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                    <option selected>Select Calendar</option>
                                                    {calendar?.map(obj =>
                                                        <>
                                                            <option value={obj?.id}>{obj?.name}</option>
                                                        </>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Description</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Description"
                                                    required
                                                    value={reqData?.description}
                                                    onChange={(e) => handleChange("description", e?.target?.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Tags</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="tags"
                                                    required
                                                    value={reqData?.tags}
                                                    onChange={(e) => handleChange("tags", e?.target?.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollege;